import type { SearchableSelectOption } from '@/components/ui/SearchableSelect'
import type { FinancialDailyReportVariant } from '../../types/pages'

export const PAYMENT_SOURCE_OPTIONS: Record<FinancialDailyReportVariant, SearchableSelectOption[]> = {
  standard: [
    { value: 'ALL', label: 'All' },
    { value: 'CARDCONNECT', label: 'CardConnect' },
    { value: 'PAYPAL', label: 'Paypal' },
    { value: 'PAYNEARME', label: 'PayNearMe' },
    { value: 'ACH', label: 'ACH' },
    { value: 'PAPER_CHECK', label: 'Paper Check' },
    { value: 'EXTERNAL', label: 'External' },
  ],
  defaults: [
    { value: 'ALL', label: 'All' },
    { value: 'ACH', label: 'ACH' },
    { value: 'PAPER_CHECK', label: 'Paper Check' },
  ],
}
